import { getOptimizedImageUrl } from '@src/utils/imageProxy.util'

function getDownloadFileName(url: string, fileName?: string, title?: string): string {
  if (title ?? fileName) return title ?? fileName ?? 'download'

  try {
    const pathname = new URL(url, window.location.href).pathname
    return pathname.split('/').pop() ?? 'download'
  } catch {
    return 'download'
  }
}

export async function downloadFile({
  url,
  fileName,
  title,
}: {
  url: string
  fileName?: string
  title?: string
}) {
  const response = await fetch(getOptimizedImageUrl(url))

  if (!response.ok) {
    throw new Error(`Failed to download: ${response.status}`)
  }

  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = getDownloadFileName(url, fileName, title)
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(blobUrl)
}
